<template>
	<v-dialog slot="activator" v-model="dialog" persistent max-width="70vw" >
		<v-btn slot="activator" >
			OCCUPANT / PI HISTORY
		</v-btn>
		<v-card>
			<v-toolbar>
				<v-toolbar-title>
					OCCUPANT / PI HISTORY
				</v-toolbar-title>
			</v-toolbar>
			<v-card-title class="body-2" color="black"></v-card-title>
			<v-card-text class="pb-5 px-5">
				<v-subheader>Occupants</v-subheader>
				<v-data-table v-if="occupantHistoryData"
				    :headers="headers"
				    :items="occupantHistoryData"
				    class="elevation-1 mb-5">
				    <template slot="items" slot-scope="props">
				    	<td class="caption" v-for="header in headers" >
							{{ props.item[header.value] }}
						</td>
				    </template>

			  	</v-data-table>
			  	<v-flex v-if="piHistoryData && piHistoryData.length > -1">
			  	<v-subheader>Principal Investigators</v-subheader>
			  	<v-data-table 
				    :headers="headers"
				    :items="piHistoryData"
				    class="elevation-1">
				    <template slot="items" slot-scope="props">
				    	<td class="caption" v-for="header in headers" >
							{{ props.item[header.value] }}
						</td>
				    </template>

			  	</v-data-table>
			  </v-flex>
			  </v-card-text>
			<v-card-actions class="pb-5 px-5">
				<v-spacer></v-spacer>
				<v-btn color="green darken-1" flat @click.native="reset">
					OK
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {

	components: {  },

	data() {
		return {
			dialog: 				false,
			occupantHistoryData: 	null,
			piHistoryData: 			null,

			headers: 			[	{ text: 'Name', value: 'name' },
									//{ text: 'Title', value: 'title' },
									{ text: 'Start Date', value: 'dateStart' },
									{ text: 'End Date', value: 'dateEnd' },						
									{ text: 'Department', value: 'departmentName' },
									{ text: 'Percentage', value: 'percentage' },
			],
		}
	},

	created: async function() {
	},

	props: [ 'selectedRoom', ],


	watch: {

		async dialog (val) { 
			if (val) { 
				this.occupantHistoryData = []
				this.occupantHistoryData = await this.fetchOccupantHistoryData(this.selectedRoom)
				console.log("return: ", this.occupantHistoryData)

				this.piHistoryData = []
				this.piHistoryData = await this.fetchPIHistoryData(this.selectedRoom)
				console.log("return: ", this.piHistoryData)
			} 

		},
	},

	computed: {
		...mapState({		//selectedRoom: state => state.space.selectedRoom,
		}),
		

	},

	methods: {
		...mapMutations([	'', '', '',		]),
		...mapActions([	 	'fetchOccupantHistoryData', 'fetchPIHistoryData', '',		]),

		save: function() {

		},

		reset: function() {
			this.dialog = false;	
		}
	}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/OccupantHistoryDialog.vue